/* eslint-disable prettier/prettier */
/* eslint-disable no-use-before-define */
import React, { Suspense, useCallback, useEffect, useState } from "react";
import { TextField, Button, Grid, Paper, Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { AiFillCalculator } from "react-icons/ai";
import { api } from "../../../../utils/api";

const date = new Date();
// const maxDateRange = date.setDate(date.getDate());

const PremiumRecalculationForm = ({
	premiumRecalcDynamicForm,
	validation,
	plan_code,
	plan_name,
	last_recalculated_on
}: any) => {
	const [isCalculating, setIsCalculating] = useState(false);
	const [openSnack, setOpenSnack] = useState(false);

	const handleRecalculation = useCallback(async () => {
		setIsCalculating(true);
		try {
			const payload = { plan_code, plan_name, last_recalculated_on };
			const response = await api.premiumRecalculation.postPremiumRecalculationForm(payload);
			setOpenSnack(true); // Show success message on successful recalculation
		} catch (error) {
			console.error("Recalculation Error:", error);
			setOpenSnack(true); // Show error message on failure
		} finally {
			setIsCalculating(false);
		}
	}, [plan_code, plan_name, last_recalculated_on]);

	const Alert = (props: AlertProps) => {
		return <MuiAlert elevation={6} variant="filled" {...props} />;
	};

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		setOpenSnack(false);
	};

	return (
		<>
			<div className="dynamic-report-form-container" id="dynamic-report-form-contianer">
				<div className="pf-action-button-container" id="pf-action-button-container">
					<Button
						className="button-green"
						variant="contained"
						onClick={handleRecalculation}
						disabled={isCalculating}
					>
						<span className="button-label-with-icon">
							{isCalculating ? "Loading ..." : "Recalculate Premium"}
						</span>
						<span>
							<AiFillCalculator className="button-icon" />
						</span>
					</Button>
				</div>

				<Grid container spacing={1} className="pf-grid-container">
					{premiumRecalcDynamicForm &&
						Object.entries(premiumRecalcDynamicForm).map(([key, value], index) => {
							return (
								<div key={index}>
									<div className="pf-title">{key}</div>
									<Suspense fallback={<div />}>
										<Paper className="pf-paper-container" elevation={3} variant="outlined">
											{value instanceof Array &&
												value.map((field, index) => {
													return (
														<Grid container spacing={1} className="pf-label" key={index}>
															<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
																<div
																	className={
																		[
																			"plan_type",
																			"plan_name",
																			"plan_code"
																		].includes(field.name)
																			? "pf-label-text required"
																			: "pf-label-text"
																	}
																	id="pf-label-text"
																>
																	{field.label}
																</div>
															</Grid>

															<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
																{field.type === "textfield" && (
																	<TextField
																		className="text-field"
																		id={
																			[
																				"plan_name",
																				"plan_code",
																				"plan_type",
																				"current_year",
																				"recalculation_trigger",
																				"last_recalculated_by",
																				"last_recalculated_on"
																			].includes(field.name)
																				? "disabled-input-text-field"
																				: "input-text-field"
																		}
																		name={field.name}
																		placeholder={field.placeholder}
																		value={field.value}
																		variant="outlined"
																		style={{ width: "340px", borderRadius: 50 }}
																		disabled={[
																			"plan_name",
																			"plan_type",
																			"plan_code",
																			"current_year",
																			"recalculation_trigger",
																			"last_recalculated_by",
																			"last_recalculated_on"
																		].includes(field.name)}
																	/>
																)}
															</Grid>
														</Grid>
													);
												})}
										</Paper>
									</Suspense>
								</div>
							);
						})}
				</Grid>
				<Snackbar open={openSnack} autoHideDuration={6000} onClose={handleClose}>
					<Alert onClose={handleClose} severity="success">
						Premium recalculation successful!
					</Alert>
				</Snackbar>
			</div>
		</>
	);
};

export default PremiumRecalculationForm;
